<template>
    <div class="row no-gutters mt-2 noselect pl-2" v-if="anyChapterSelected" @dblclick="insertEmptyChapter">
        <div class="col-12">
            <h3 class="pointer noselect rounded text-center ml-2 mr-2 shadow-sm" style="line-height: 50px;">
                <i class="fa fa-plus"></i> {{ $t('INSTANCE_INSERT_EMPTY_CHAPTER') }}
            </h3>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from '../../../../../repositories/RepositoryFactory';

const ChapterLiveRepository = RepositoryFactory.get('chaptersLive');
const InstanceRepository = RepositoryFactory.get('instances');

export default {
  name: 'InsertEmptyChapter',
  data() {
    return {};
  },
  methods: {
	      async insertEmptyChapter() {
		      if (!this.anyChapterSelected) { return false; }

		      await ChapterLiveRepository.insertEmptyChapter().then((res) => {
			      InstanceRepository.refetchActive(false);
		      });
	      },
  },
  computed: {
    anyChapterSelected() {
      if (!this.$store.getters.instanceInLiveMode) {
        return false;
      }
      if (this.$store.getters.instanceLiveData.currentChapter === null) {
        return false;
      }

      return true;
    },
  },
};
</script>

<style scoped>
    h3 {
        color: white;
        background-color: indianred;
    }
    h3:hover {
        color: lightgray;
    }
</style>
